<app-logo [link]='link' [logos]="$any({
  small: { src: './assets/images/logo-s.png', minWidth: 45, height: 45, width: 45},
  normal: { src: './assets/images/logo-m.png', minWidth: 185, height: 45, width: 185}})">
</app-logo>
